import { ReactNode, createContext } from "react";
import useFluxoCaixa, { FluxoCaixaType, CreateFluxoCaixaType, EditFluxoCaixaType } from "./hooks/useFluxoCaixa";

interface FluxoCaixaContextProviderProps {
    children: ReactNode;
}

export interface FluxoCaixaContextData {
    createFluxoCaixa: (createFluxoCaixaData: CreateFluxoCaixaType) => Promise<CreateFluxoCaixaType | null>;
    getAllFluxoCaixaPaged: (
        pageNumber?: number,
        pageSize?: number,
        EmpresaId?: number,
        dataInicial?: string,
        dataFinal?: string,
    ) => Promise<FluxoCaixaType[] | null>;
    updateFluxoCaixa: (editFluxoCaixaData: EditFluxoCaixaType) => Promise<EditFluxoCaixaType | null>;
    deleteFluxoCaixa: (fluxoCaixaId: number) => Promise<FluxoCaixaType | null>;
    setFluxoCaixa: any;
    fluxoCaixa: FluxoCaixaType;
    listFluxoCaixa: FluxoCaixaType[];
    initialListFluxoCaixa: FluxoCaixaType[];
    setListFluxoCaixa: (fluxoCaixa: FluxoCaixaType[]) => void;
    setFluxoCaixaPageCount: (count: number) => void;
    fluxoCaixaPageCount: number;
}

const initialState: FluxoCaixaContextData = {
    createFluxoCaixa: async () => null,
    getAllFluxoCaixaPaged: async () => null,
    updateFluxoCaixa: async () => null,
    deleteFluxoCaixa: async () => null,
    setFluxoCaixa: () => { },
    fluxoCaixa: {
        id: 0,
        description: "",
        value: "",
        date: "",
        tipoMovimento: 0,
        empresaId: 0,
        contaFinanceiraId: 0,
        contaFinanceiraName: "",
        categoriaFinanceiraId: 0,
        categoriaFinanceiraName: "",
        openingBalance: 0,
        finalBalance: 0,
    },
    listFluxoCaixa: [],
    initialListFluxoCaixa: [],
    setListFluxoCaixa: () => { },
    setFluxoCaixaPageCount: () => { },
    fluxoCaixaPageCount: 0,
};

export const FluxoCaixaContext =
    createContext<FluxoCaixaContextData>(initialState);

export default function FluxoCaixaContextProvider({
    children,
}: FluxoCaixaContextProviderProps) {
    const {
        createFluxoCaixa,
        getAllFluxoCaixaPaged,
        updateFluxoCaixa,
        deleteFluxoCaixa,
        fluxoCaixa,
        listFluxoCaixa,
        initialListFluxoCaixa,
        setListFluxoCaixa,
        setFluxoCaixaPageCount,
        fluxoCaixaPageCount,
    } = useFluxoCaixa();

    return (
        <FluxoCaixaContext.Provider
            value={{
                createFluxoCaixa,
                getAllFluxoCaixaPaged,
                updateFluxoCaixa,
                deleteFluxoCaixa,
                setFluxoCaixa: () => { },
                fluxoCaixa,
                listFluxoCaixa,
                initialListFluxoCaixa,
                setListFluxoCaixa,
                setFluxoCaixaPageCount,
                fluxoCaixaPageCount,
            }}
        >
            {children}
        </FluxoCaixaContext.Provider>
    );
}
